import React, { useEffect } from 'react';

import { checkAndSetConsent } from './utilities/consent';
import { SegmentAnalytics } from 'config/SegmentAnalytics';
import { NotificationsContainer } from 'utilities/notificationUtils';

import GlobalStyle from './GlobalStyle';
import { Router } from './Router';

const App = () => {
  useEffect(() => {
    checkAndSetConsent();
  }, []);

  return (
    <>
      <SegmentAnalytics />
      <NotificationsContainer />
      <GlobalStyle />
      <Router />
    </>
  );
};

export default App;
